/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

export const ColumnVisibilityModal = ({ isOpen, onClose, table }) => {
  const [allColumnsVisible, setAllColumnsVisible] = useState(false);

  // Update allColumnsVisible state when column visibility changes
  useEffect(() => {
    const visibleColumns = table
      .getAllLeafColumns()
      .filter(col => col.getIsVisible());
    setAllColumnsVisible(
      visibleColumns.length === table.getAllLeafColumns().length
    );
  }, [table.getState().columnVisibility]);

  // Handle toggle all columns
  const handleToggleAll = () => {
    const newValue = !allColumnsVisible;
    const newVisibility = {};
    table.getAllLeafColumns().forEach(column => {
      newVisibility[column.id] = newValue;
    });
    table.setColumnVisibility(newVisibility);
    setAllColumnsVisible(newValue);
  };

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Column Visibility</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Add Toggle All checkbox */}
        <div className="form-check mb-3 border-bottom pb-2">
          <input
            type="checkbox"
            className="form-check-input"
            checked={allColumnsVisible}
            onChange={handleToggleAll}
            id="toggle-all-columns"
          />
          <label
            className="form-check-label fw-bold"
            htmlFor="toggle-all-columns"
          >
            Show All Columns
          </label>
        </div>

        {/* Individual column toggles in 2 columns */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '0.5rem',
            maxHeight: '400px',
            overflowY: 'auto'
          }}
        >
          {table.getAllLeafColumns().map(column => (
            <div key={column.id} className="form-check mb-2">
              <input
                type="checkbox"
                className="form-check-input"
                checked={column.getIsVisible()}
                onChange={column.getToggleVisibilityHandler()}
                id={column.id}
              />
              <label className="form-check-label" htmlFor={column.id}>
                {column.columnDef.header}
              </label>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};
